import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchPrefixes, patchPrefixes, createPrefixes } from "./services/PurchaseService";
import { CACHE_TTL_MS } from "./ttl.cache";

export const usePrefixes = (options = {}) => {
  const queryClient = useQueryClient();

  const prefixesQuery = useQuery({
    queryKey: ["prefixes"],
    queryFn: async () => {
      const apiData = await fetchPrefixes();
      return apiData;
    },
    staleTime: CACHE_TTL_MS.TTL_24_HOURS,
    cacheTime: CACHE_TTL_MS.TTL_24_HOURS,
    refetchOnMount: false,
    ...options,
  });

  const patchMutation = useMutation({
    mutationFn: async ({ inputs, hasToRemovePrefix = false }) => {
      const result = await patchPrefixes(inputs, hasToRemovePrefix);
      if (!result) return;
      return result;
    },
    onSuccess: (data) => {
      if (!data) return;
      queryClient.invalidateQueries(["prefixes"]);
    },
  });

  const createMutation = useMutation({
    mutationFn: async (input) => {
      return createPrefixes(input);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["prefixes"]);
    },
  });

  return {
    ...prefixesQuery,
    patchPrefixes: patchMutation.mutateAsync,
    isUpdating: patchMutation.isLoading,
    isUpdateError: patchMutation.isError,
    updateError: patchMutation.error,
    createPrefix: createMutation.mutateAsync,
    isCreating: createMutation.isLoading,
    isCreateError: createMutation.isError,
    createError: createMutation.error,
  };
};